<template>
  <div class="evento-biomasa-view container-fluid mt-4">
    <!-- Menú compacto de gestión -->
    <div class="gestion-tabs mb-3">
      <div v-for="opcion in opcionesFiltradas" :key="opcion.nombre" class="tab-item" :data-tab="opcion.nombre"
        :class="{ active: activeTab === opcion.nombre }" @click="activeTab = opcion.nombre">
        <font-awesome-icon :icon="opcion.icono" class="me-2" />
        {{ opcion.label }}
      </div>
    </div>

    <!-- Contenido dinámico -->
    <component :is="activeComponent" :proyecto_evento_id="proyecto_evento_id" :proyecto_id="proyecto_id"
      @biomasaGuardada="onBiomasaGuardada" @cancel="closeForm" />
  </div>
</template>

<script>
import ListarBiomasaEvento from '@/components/BiomasaEvento/ListarBiomasaEvento.vue';
import MoverBiomasaEvento from '@/components/BiomasaEvento/MoverBiomasaEvento.vue';
import MarcarBiomasaListaProducir from '@/components/BiomasaEvento/marcarBiomasaListaProducir.vue';
import biomasaForm from '@/components/Biomasa/biomasaForm.vue';

export default {
  name: 'EventoBiomasaView',
  components: {
    ListarBiomasaEvento,
    MoverBiomasaEvento,
    MarcarBiomasaListaProducir,
    biomasaForm
  },
  props: {
    proyecto_id: Number,
    proyecto_evento_id: Number
  },
  data() {
    return {
      evento_actual: this.$store.getters.getEventoActual,
      activeTab: 'listar'
    };
  },
  computed: {
    activeComponent() {
      return {
        listar: 'ListarBiomasaEvento',
        mover: 'MoverBiomasaEvento',
        crear: 'biomasaForm',
        marcarBiomasaListaProducir: 'MarcarBiomasaListaProducir'
      }[this.activeTab] || 'ListarBiomasaEvento';
    },
    opcionesFiltradas() {
      const base = [
        { nombre: 'listar', label: 'Listar Biomasa', icono: ['fas', 'leaf'] },
        { nombre: 'mover', label: 'Mover Biomasa', icono: ['fas', 'arrow-right-arrow-left'] },
        { nombre: 'marcarBiomasaListaProducir', label: 'Marcar como Lista', icono: ['fas', 'check-double'] }
      ];

      if (this.evento_actual?.evento_cultivo.nombre_evento?.toLowerCase() === 'cosecha') {
        base.splice(2, 0, {
          nombre: 'crear',
          label: 'Crear Biomasa',
          icono: ['fas', 'plus-circle']
        });
      }

      return base;
    }
  }
  ,
  methods: {
    onBiomasaGuardada() {
      this.activeTab = 'listar';
    },
    closeForm() {
      this.activeTab = 'listar';
    }
  }
};
</script>

<style scoped>
.evento-biomasa-view {
  background: #fff;
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.05);
}

.gestion-tabs {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  border-bottom: 1px solid #e0e0e0;
  margin-bottom: 20px;
}

.tab-item {
  padding: 8px 14px;
  border-radius: 8px 8px 0 0;
  background-color: #f7f7f7;
  color: #444;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.tab-item:hover {
  background-color: #ececec;
}

/* Activo: Listar, Mover → Verde biomasa */
.tab-item.active[data-tab="listar"],
.tab-item.active[data-tab="mover"] {
  background-color: #e9f7ee;
  color: #28a745;
  border-bottom: 2px solid #28a745;
}

/* Activo: Crear → Naranja terracota */
.tab-item.active[data-tab="crear"] {
  background-color: #fef0e9;
  color: #a84e1a;
  border-bottom: 2px solid #a84e1a;
}

/* Activo: Marcar como Lista → Rojo (alerta) */
.tab-item.active[data-tab="marcarBiomasaListaProducir"] {
  background-color: #faeaea;
  color: #dc3545;
  border-bottom: 2px solid #dc3545;
}
</style>
